import { render, staticRenderFns } from "./RankView.vue?vue&type=template&id=543bd0fe&scoped=true&"
import script from "./RankView.vue?vue&type=script&lang=ts&"
export * from "./RankView.vue?vue&type=script&lang=ts&"
import style0 from "./RankView.vue?vue&type=style&index=0&id=543bd0fe&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543bd0fe",
  null
  
)

export default component.exports